import React from 'react';

const Preloader = () => {
  return (
    <div className="uni-preloader">
        <div className="loading">
            <div></div><div></div><div></div><div></div>
        </div>
    </div>
  );
};

export default Preloader;